import { z } from "zod";

export const DemoFleetConfigSchema = z
  .object({
    maxDatabaseConnections: z.number().int().positive().default(3),
    maxCachedContexts: z.number().int().positive().default(20),
    failedContextRetryMs: z.number().int().positive().default(60_000),
    contextIdleMs: z.number().int().positive().default(300_000),
    configCacheMs: z.number().int().positive().default(60_000),
    maxConcurrentWork: z.number().int().min(2).default(20),
    maxConcurrentWorkPerDemo: z.number().int().positive().default(5),
    maxConcurrentSandboxes: z.number().int().min(2).default(6),
    maxConcurrentSandboxesPerDemo: z.number().int().positive().default(2),
    capacityPollMs: z.number().int().positive().default(1_000),
    sessionLifetimeSeconds: z.number().int().positive().default(86_400),
    workerReadLimit: z.number().int().positive().default(200),
  })
  .strict();
export type DemoFleetConfig = z.infer<typeof DemoFleetConfigSchema>;
